import 'bootstrap/js/dist/collapse';
import './collapse.scss';
